import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Swiper from 'swiper';

class Caroussel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            swiper: null,
            width: 0,
            windowWidth: 0,
            swiperDestroyed: false,
            swiperInit: false
        }
    }

    componentDidMount() {
        this.setState({
            windowWidth: window.innerWidth
        })
        window.addEventListener('resize', this.onResize.bind(this));
        if (this.props.maxshow >= window.innerWidth || this.props.maxshow === undefined) {
            if (this.props.minshow <= window.innerWidth || this.props.minshow === undefined) {
                this.initSwiper();
            }
        }
    }

    initSwiper() {
        this.setState({
            swiperInit: true
        })
        let width = window.innerWidth;
        let slidesPerView = 0;

        if (width < 1024) {
            if (width < 480) {
                slidesPerView = this.props.mobile !== undefined ? this.props.mobile : 1.3;
            }
            else {
                slidesPerView = this.props.tablet !== undefined ? this.props.tablet : 2.2;
            }
        }
        else {
            slidesPerView = this.props.desktop !== undefined ? this.props.desktop : 3;
        }

        this.setState({
            swiper: new Swiper("." + this.props.classcontainer + " .swiper-container", {
                loop: false,
                slidesPerView: slidesPerView,
                spaceBetween: 30,
                pagination: "." + this.props.classcontainer + ' .swiper-pagination',
                paginationClickable: true,
                nextButton: "." + this.props.classcontainer + ' .swiper-button-next',
                prevButton: "." + this.props.classcontainer + ' .swiper-button-prev',
            }),
            windowWidth: window.innerWidth,
        }, () => this.callbackInitSwiper())
    }

    callbackInitSwiper() {
        const classContainer = document.querySelector('.' + this.props.classcontainer + ' .swiper-pagination')
        let totalBullets = 0
        if (classContainer) {
            setTimeout(() => {
                totalBullets = classContainer.childNodes.length
                if (totalBullets < 2) {
                    classContainer.classList.add('swiper-pagination-hidden')
                }
                else {
                    classContainer.classList.remove('swiper-pagination-hidden')
                }
            }, 0)
        }
    }

    onResize() {
        let width = window.innerWidth;
        let slidesPerView = 0;
        let updateSwiper = false;

        if ((width < 1024 && width >= 480) && (this.state.windowWidth >= 1024 || this.state.windowWidth < 480)) {
            slidesPerView = this.props.tablet !== undefined ? this.props.tablet : 2.2;
            updateSwiper = true;
        }
        else if (width < 480 && this.state.windowWidth >= 480) {
            slidesPerView = this.props.mobile !== undefined ? this.props.mobile : 1.3;
            updateSwiper = true;
        }
        else if (width >= 1024 && this.state.windowWidth < 1024) {
            slidesPerView = this.props.desktop !== undefined ? this.props.desktop : 3;
            updateSwiper = true;
        }

        if (this.props.maxshow < width) {
            updateSwiper = false;
            if (!this.state.swiperDestroyed && this.state.swiperInit) {
                this.setState(
                    {
                        swiperDestroyed: true
                    }
                )
                this.state.swiper.destroy(true, true)
            }
        } else {
            if (this.state.swiperDestroyed || !this.state.swiperInit) {
                this.setState({
                    swiperDestroyed: false
                })
                this.initSwiper()
            }
        }

        if (this.props.minshow > width) {
            updateSwiper = false;
            if (!this.state.swiperDestroyed && this.state.swiperInit) {
                this.setState(
                    {
                        swiperDestroyed: true
                    }
                )
                this.state.swiper.destroy(true, true)
            }
        } else {
            if (!this.props.minshow === undefined) {
                if (this.state.swiperDestroyed || !this.state.swiperInit) {
                    this.setState({
                        swiperDestroyed: false
                    })
                    this.initSwiper()
                }
            }
        }

        if (updateSwiper) {
            this.state.swiper.params.slidesPerView = slidesPerView;
            this.callbackInitSwiper()
        }
        this.setState({
            windowWidth: width
        })
    }

    render() {
        return <div></div>
    }
}

Caroussel.propTypes = {
    mobile: PropTypes.string,
    tablet: PropTypes.string,
    desktop: PropTypes.string,
    maxshow: PropTypes.string,
    minshow: PropTypes.string,
    classcontainer: PropTypes.string.isRequired,
    total: PropTypes.string
}

export default (Caroussel);



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/carousel-block/Caroussel.js